<div class="modal-dialog modal-lg create-invoice-page" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="col-sm-12">
        <h5 class="modal-title title" [innerHTML]="data.isCopy ? 'Copy Invoice' : 'Add Invoice'"></h5>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fas fa-times"></span>
      </a>
    </div>
    <div class="modal-body">
      <div class="main-content">
        <div class="row">
          <div class="col">
            <app-invoice-details
              *ngIf="inquiry"
              [inquiry]="inquiry"
              (update)="onInvoiceDetailChanged($event)"
              [invoice]="invoice"
              [rootForm]="form"
              (save)="onSaveInvoice(form)"
              (close)="close()"
            >
            </app-invoice-details>

            <div class="row invoice-title-holder">
              <div class="col-sm-8 col-xl-9">
                <div class="px-4">
                  <div class="row">
                    <div class="col-sm-5">
                      <div class="item-title">{{ lineItemTitles?.item }}</div>
                    </div>
                    <div class="col-sm-2">
                      <div class="item-title">{{ lineItemTitles?.unit }}</div>
                    </div>
                    <div class="col-sm-2">
                      <div class="item-title">{{ lineItemTitles?.qty }}</div>
                    </div>
                    <div class="col-sm-3">
                      <div class="item-title">{{ lineItemTitles?.discountFees }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 col-xl-3">
                <div class="item-title pdl-15">{{ lineItemTitles?.tax }}</div>
              </div>
            </div>

            <div *ngIf="rental">
              <app-invoice-item
                *ngFor="let item of invoice.invoiceItems; let idx = index; trackBy: trackByIndex"
                [rootForm]="form"
                [item]="item"
                [guests]="guests"
                [rental]="rental"
                [currency]="invoice?.currency"
                [removable]="idx"
                [invoiceType]="invoiceType"
                [lineTotal]="invoiceTotalData?.line_items[idx]"
                [isRefreshTotal]="isRefreshTotal"
                (itemChange)="onLineItemChanged(idx, $event)"
                (remove)="onRemoveLineItem(idx, $event)"
              ></app-invoice-item>
            </div>

            <div class="row invoice-holder">
              <div class="col-sm-8 col-xl-9">
                <button type="button" class="btn btn-success text-uppercase" (click)="onAddInvoiceItem()">
                  <span class="fal fa-plus"></span> Add Line Item
                </button>
              </div>
              <div class="col-sm-4 col-xl-3">
                <div class="clearfix container-box tax-holder invoice-total-summary">
                  <div class="row tax-row">
                    <div class="col-6">Invoice Total</div>
                    <div class="col-6 text-right">
                      <strong>
                        <app-loading-value
                          [value]="invoiceTotalData?.total | tokeetCurrency : invoice?.currency"
                          [loading]="isRefreshTotal"
                        ></app-loading-value>
                      </strong>
                    </div>
                  </div>
                  <div class="row tax-row">
                    <div class="col-6">Paid to Date</div>
                    <div class="col-6 text-right">
                      <span>
                        <strong *ngIf="invoice.status !== invoiceStatuses.Paid">
                          {{ 0 | tokeetCurrency : invoice?.currency }}
                        </strong>
                        <strong *ngIf="invoice.status === invoiceStatuses.Paid">
                          <app-loading-value
                            [value]="invoiceTotalData?.total | tokeetCurrency : invoice?.currency"
                            [loading]="isRefreshTotal"
                          ></app-loading-value>
                        </strong>
                      </span>
                    </div>
                  </div>
                  <div class="row tax-row total">
                    <div class="col-6">
                      <strong>Balance ({{ invoice.currency?.code }})</strong>
                    </div>
                    <div class="col-6 text-right">
                      <span class="total-price">
                        <strong *ngIf="invoice.status !== invoiceStatuses.Paid">
                          <app-loading-value
                            [value]="invoiceTotalData?.total | tokeetCurrency : invoice?.currency"
                            [loading]="isRefreshTotal"
                          ></app-loading-value>
                        </strong>
                        <strong *ngIf="invoice.status === invoiceStatuses.Paid">
                          {{ 0 | tokeetCurrency : invoice?.currency }}
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <app-invoice-notes
              *ngIf="rental?.id"
              [rootForm]="form"
              [notes]="invoice.notes"
              [paymentTerms]="invoice.paymentTerms"
              [paymentInstructions]="invoice.paymentInstructions"
              (update)="onInvoiceNotesChanged($event)"
            ></app-invoice-notes>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
